import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {ScrollToPlugin} from 'gsap/all';
import Lenis from 'lenis';

export default function scrollTriggerFunctions() {
    gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

    const lenis = new Lenis();

    lenis.stop();

    jQuery(document).ready(function () {
        lenis.start();
    });

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    const isMobile = window.matchMedia('(max-width: 1024px)').matches;

    document.querySelectorAll('a[href^="#"]').forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            const id = el.getAttribute('href')?.slice(1);
            if (!id) return;
            const target = document.getElementById(id);
            if (target) {
                setTimeout(() => {
                    target.scrollIntoView({behavior: 'smooth'});
                }, 200);
            }
        });
    });

    // Foreach .animate-up element use scrolltrigger to animate the element from the bottom to the top
    let animateUp = document.querySelectorAll('.animate-up');
    if (animateUp) {
        gsap.utils.toArray(animateUp).forEach((el) => {
            gsap.from(el, {
                y: 50,
                opacity: 0,
                duration: 0.25,
                animationDuration: 1,
                scrollTrigger: {
                    trigger: el,
                    start: 'top 90%',
                    end: 'bottom 90%',
                    scrub: true,
                },
            });
        });
    }

    // Fade in each .animate-fade element
    let animateFade = document.querySelectorAll('.animate-fade');
    if (animateFade) {
        gsap.utils.toArray(animateFade).forEach((el) => {
            gsap.from(el, {
                opacity: 0,
                duration: 1,
                scrollTrigger: {
                    trigger: el,
                    start: 'top 80%',
                    end: 'bottom 80%',
                    scrub: true,
                    markers: false,
                },
            });
        });
    }
}
